import {callApi, updateStatus} from "../05-utils/commonUtils";
import {getEnv} from "../env";

const ACTIONS = {
  CATEGORIES_LOADING: "CATEGORIES_LOADING",
  CATEGORIES_LOADED: "CATEGORIES_LOADED",
  CATEGORIES_LOAD_FAILED: "CATEGORIES_LOAD_FAILED",
  CATEGORY_ADDING: "CATEGORY_ADDING",
  CATEGORY_ADDED: "CATEGORY_ADDED",
  CATEGORY_ADD_FAILED: "CATEGORY_ADD_FAILED",
  CATEGORY_REMOVING: "CATEGORY_REMOVING",
  CATEGORY_REMOVED: "CATEGORY_REMOVED",
  CATEGORY_REMOVE_FAILED: "CATEGORY_REMOVE_FAILED",
  CATEGORY_UPDATING: "CATEGORY_UPDATING",
  CATEGORY_UPDATED: "CATEGORY_UPDATED",
  CATEGORY_UPDATE_FAILED: "CATEGORY_UPDATE_FAILED",
  CATEGORY_SWAPPING: "CATEGORY_SWAPPING",
  CATEGORY_SWAPPED: "CATEGORY_SWAPPED",
  CATEGORY_SWAP_FAILED: "CATEGORY_SWAP_FAILED",
};

const loadCategories = (data) => {
  let config = {
    method: "post",
    body: {withProductCount: data && data.withProductCount},
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.CATEGORIES_LOADING));
    callApi(
      getEnv("API_SERVER") + "/category/all",
      config,
      null,
      (data) => {
        dispatch(
          updateStatus(ACTIONS.CATEGORIES_LOADED, {
            categories: data.categories,
          }),
        );
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.CATEGORIES_LOAD_FAILED, {error: err}));
      },
    );
  };
};

const addCategory = (data) => {
  let config = {
    method: "post",
    body: {name: data.value, parentId: data.parent},
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.CATEGORY_ADDING, {newCategory: config.body}));
    callApi(
      getEnv("API_SERVER") + "/category",
      config,
      null,
      (data) => {
        dispatch(
          updateStatus(ACTIONS.CATEGORY_ADDED, {
            _id: data._id,
            order: data.order,
          }),
        );
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.CATEGORY_ADD_FAILED, {error: err}));
      },
    );
  };
};

const deleteCategory = (data) => {
  let config = {
    method: "post",
    body: {_id: data._id},
    headers: {authorization: data.authorization},
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.CATEGORY_REMOVING, config.body));
    callApi(
      getEnv("API_SERVER") + "/category/remove",
      config,
      null,
      (data) => {
        dispatch(updateStatus(ACTIONS.CATEGORY_REMOVED, data));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.CATEGORY_REMOVE_FAILED, err));
      },
    );
  };
};

const updateCategory = (data) => {
  let config = {
    method: "post",
    body: {_id: data._id, name: data.name, parentId: data.parentId},
    headers: {authorization: data.authorization},
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.CATEGORY_UPDATING, config.body));
    callApi(
      getEnv("API_SERVER") + "/category/update",
      config,
      null,
      () => {
        dispatch(updateStatus(ACTIONS.CATEGORY_UPDATED));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.CATEGORY_UPDATE_FAILED, {error: err}));
      },
    );
  };
};

const swapCategories = (data) => {
  let config = {
    method: "post",
    body: {id1: data.id1, id2: data.id2},
    headers: {authorization: data.authorization},
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.CATEGORY_SWAPPING, config.body));
    callApi(
      getEnv("API_SERVER") + "/category/swap",
      config,
      null,
      () => {
        dispatch(updateStatus(ACTIONS.CATEGORY_SWAPPED, data));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.CATEGORY_SWAP_FAILED, {error: err}));
      },
    );
  };
};

export {
  ACTIONS,
  loadCategories,
  addCategory,
  deleteCategory,
  updateCategory,
  swapCategories,
};



// WEBPACK FOOTER //
// ./src/01-actions/adminCategories.js